// Drift: Løn på Supabase (del af SupabaseApi – se supabase.ts). Beregningen sker i databasen
// (20261107000000_loen.sql, samme regler som src/core/loen.ts); godkendte perioder er låst dér.
import type { Api } from './api';
import { ApiFejl } from './api';
import { oversigtFraDb, opsaetningFraDb, periodeFraDb, talFraDb, tjekLoenModel, tjekLoenSteamer } from '../../core/loen';
import type { SbKontekst } from './sbKatalog';

export class SbLoen {
  constructor(private readonly c: SbKontekst) {}
  private async rpc<T>(navn: string, a: Record<string, unknown> = {}): Promise<T> {
    return (await this.c.k(this.c.sb.rpc(navn, { k: await this.c.kraevKlient(), ...a }))) as T;
  }
  loenPeriode: Api['loenPeriode'] = async (steamer_id, fra) => periodeFraDb(await this.rpc('loen_periode', { p_steamer: steamer_id, p_fra: fra }));
  loenOversigt: Api['loenOversigt'] = async (fra) => oversigtFraDb(await this.rpc('loen_oversigt', { p_fra: fra }));
  loenGodkend: Api['loenGodkend'] = async (steamer_id, fra) => talFraDb(await this.rpc('loen_godkend', { p_steamer: steamer_id, p_fra: fra }));
  loenOpsaetning: Api['loenOpsaetning'] = async () => opsaetningFraDb(await this.rpc('loen_opsaetning'));
  gemLoenModel: Api['gemLoenModel'] = async (m) => {
    const f = tjekLoenModel(m);
    if (Object.keys(f).length) throw new ApiFejl(Object.values(f)[0], f);
    await this.rpc('gem_loen_model', { p: m });
  };
  gemLoenSteamer: Api['gemLoenSteamer'] = async (s) => {
    const f = tjekLoenSteamer(s);
    if (f) throw new ApiFejl(f);
    const { steamer_id, ...p } = s;
    await this.rpc('gem_loen_steamer', { p_steamer: steamer_id, p });
  };
  gemLoenFirma: Api['gemLoenFirma'] = async (l) => {
    if (l.some((x) => !x.navn.trim() || x.navn.trim().length > 80)) throw new ApiFejl('Skriv et navn på hver firmakunde (højst 80 tegn).');
    await this.rpc('gem_loen_firma', { p: l.map((x) => ({ navn: x.navn.trim(), partner_id: x.partner_id, kunde_id: x.kunde_id })) });
  };
}
